export default "__VITE_ASSET__zECQVgUu__"